import { Link } from "react-router-dom";
import { useAuth } from "../auth/useAuth";

const UnauthorizedPage = () => {
  const { logout, user } = useAuth();

  return (
    <div className="midpoint-app auth-page">
      <div className="auth-login-card panel-card">
        <p className="eyebrow">Midpoint</p>
        <h1>Access denied</h1>
        <p className="muted">
          You are signed in
          {user?.email ? ` as ${user.email}` : ""}, but your account does not
          have permission to access this page. If your role was recently changed,
          sign out and sign in again so permissions refresh.
        </p>
        <div className="auth-login-form auth-unauthorized-actions">
          <Link to="/" className="midpoint-share-button">
            Back to map
          </Link>
          <button
            type="button"
            className="midpoint-share-button"
            onClick={() => logout()}
          >
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
